import i18n from '@/vue-app/plugins/i18n';

export default class SowosPocketInfoViewModel {
  readonly i18n_namespace = 'components.home-dashboard.modal_new_investment';

  translate = (value: string) => (
    i18n.t(`${this.i18n_namespace}.${value}`) as string
  )
}
